import { Injectable, inject } from '@angular/core';

import { StorageService } from '@shared/services';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectStorageService {
  private storage = inject(StorageService);

  get(): Observable<any[]> {
    return from(this.storage.get('projects'));
  }

  save(projects: any[]): Observable<any> {
    return from(this.storage.set('projects', projects));
  }

}
